// src/components/DescriptionBox.tsx
import React, { useState, useRef, useEffect } from 'react'
import LinkButton from '@/components/atoms/LinkButton/LinkButton'
import IconChevronDownXs from '@/components/icons/IconChevronDownXs/IconChevronDownXs'

interface MoreAboutContentSectionProps {
  header: string
  title: string
  content: string
}

const MoreAboutContentSection: React.FC<MoreAboutContentSectionProps> = ({
  header,
  title,
  content
}) => {
  const [showMoreVisible, setShowMoreVisible] = useState(false)
  const descriptionRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (descriptionRef.current) {
      const height = descriptionRef.current.offsetHeight
      if (height >= 648) {
        setShowMoreVisible(true)
      }
    }
  }, [])

  return (
    <article className="flex flex-col gap-1">
      <div className="flex max-w-[456px] flex-col items-start gap-1 md:gap-2">
        <div className="text-sm font-semibold uppercase tracking-[1px] text-primary-400">
          {header}
        </div>
        <div className="font-FieldsVariable text-2xl font-medium text-gray-1100">
          {title}
        </div>
      </div>

      <div
        className="prose prose-base max-w-full prose-headings:text-gray-900 prose-h2:text-xl prose-h3:text-lg
          prose-p:text-base prose-p:text-gray-800 prose-a:text-base prose-a:text-gray-800 prose-strong:text-gray-800 prose-li:text-gray-800"
        ref={descriptionRef}
      >
        <div
          className={`${
            showMoreVisible ? 'max-h-[648px]' : ''
          } overflow-y-hidden`}
          dangerouslySetInnerHTML={{ __html: content }}
        />
        {showMoreVisible && (
          <div
            className="relative cursor-pointer"
            onClick={() => setShowMoreVisible(false)}
          >
            <div className="absolute inset-x-0 -bottom-px h-28 bg-[linear-gradient(180deg,rgba(255,255,255,0.00)_0%,#FFF_73%)]" />
            <LinkButton
              className="absolute bottom-1 left-0 !text-base"
              label="Show More"
              iconElement={
                <IconChevronDownXs
                  strokeWidth="0.2"
                  className="ml-2 text-black"
                />
              }
            />
          </div>
        )}
      </div>
    </article>
  )
}

export default MoreAboutContentSection
